import React from "react";

const Stat_Describing_Data = () => {
  return (
    <div>
      <h1>Stat Describing Data</h1>
    </div>
  );
};

export default Stat_Describing_Data;
